import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { UtilIntegrationService } from 'src/app/service/util-integration.service';
import * as CONSTANTS from '../../constants';
declare var $: any;
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { UserIdleService } from 'angular-user-idle';
import { environment } from 'src/environments/environment';
import { LocationStrategy } from '@angular/common';
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';
import { Subscribable, Subscription } from 'rxjs';
import { maModel } from 'src/app/model/pre-qual-data.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'request-callback',
    templateUrl: './request-callback.component.html',
    styleUrls: ['./request-callback.component.less'],
    providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class RequestCallbackComponent implements OnInit,OnDestroy {
    currentLang: string;
    applicantEmail: string;
    requestPreQual: any;
    currLangEn = 'en';
    currLangFr = 'fr';
    prequalType = 'P';
    switchType = 'S';
    message: boolean;
    olbStatus = null;
    creditBureauError: boolean = false;
    timoutIssue: boolean = false;
    genericIssue: boolean = false;
    unSubMaAssigned: Subscription;
    maObj: maModel;
    maObjPresent: boolean=false;
    isReferralMaPresent: boolean=false;
    referral: boolean=false;
    constructor(private util: UtilService, private i18nService: I18nService,
        private storageService: WebStorageService, private userIdle: UserIdleService,
        private utilIntegration: UtilIntegrationService,
        private router: Router, private _activatedRoute: ActivatedRoute, private translate: TranslateService,
        private location: LocationStrategy) {
        this.util.sidebarTitle.next('slideTitles.requestCallback');
        this.util.progressPercent.next(0);
        this.util.isSidebarVisible.next(true);
        this._activatedRoute.queryParams.subscribe(params => {
            if (this.util.getReferral(params)) {
                this.referral = true;
            }
        });
    }
    ngOnInit(): void {
        this.unSubMaAssigned = this.util.IS_MA_ASSIGNED.subscribe(retObj => {
            if (retObj.setObj) {
                this.maObjPresent = true;
                if (retObj.maModelObj != null) {
                    this.maObj = retObj.maModelObj;
                    this.isReferralMaPresent = true;
                }
          this.setSidebar()
            }
        })
        this.requestPreQual = this.util.getSessionStorage();
        document.getElementById("sidebarTitle").focus();


        this.location.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
        history.pushState(null, null, window.location.href);
        window.onpopstate = () => setTimeout(() => {
        }, 0);
        this.currentLang = sessionStorage.getItem("lang_ref");
        this.util.getJson(atob(sessionStorage.getItem("transactionid"))).subscribe((result: any) => {
            this.requestPreQual = result;
            if (this.requestPreQual.failure_code == CONSTANTS.applicationConstants.RatingForTradesExclusion || this.requestPreQual.failure_code == CONSTANTS.applicationConstants.minimumBureauScoreExclusion || this.requestPreQual.failure_code == CONSTANTS.applicationConstants.creditBureauNoHit || this.requestPreQual.failure_code == CONSTANTS.applicationConstants.bankruptcyExclusion || this.requestPreQual.failure_code == CONSTANTS.applicationConstants.retailPublicRecordExclusion || this.requestPreQual.failure_code == CONSTANTS.applicationConstants.applicantReportedDeceased) {
                this.creditBureauError = true;
            }
            else if (this.requestPreQual.failure_code == CONSTANTS.applicationConstants.unknownException) {
                this.timoutIssue = true;
            }
            else {
                this.genericIssue = true;
            }
        }
            , (error) => {
                this.genericIssue = true;
            })
        this.checkMaIsAvailable() ;
    }
    checkMaIsAvailable() {
        let maDetail: any = this.util.getSessionStorageGeneric('maReferralLink');
        if (maDetail != undefined) {
            this.maObjPresent = maDetail.maObjPresent;
            this.isReferralMaPresent = maDetail.isReferralMaPresent;
            this.maObj = maDetail.maObj;
            this.setSidebar();
        }
    }

    onRequestCall() {
        this.util.CLOSE_WINDOW_POPUP.next(false);
        if (this.requestPreQual.flow_type == this.switchType) {
            if (this.requestPreQual.is_coapplicant_applied == 'Y') {
                var application = "co-application"
            }
            else {
                var application = "application"
            }
            var digitalData = {
                "events": {
                    "siteInteraction": true
                },
                "interaction": {
                    "name": `cibc:digital-switch:${application}:request-a-call`
                }

            };

            var digitalDataStr = JSON.stringify(digitalData)
            this.util.AdobeData(digitalDataStr);
        }

        if (!this.referral) {
            if (this.currentLang == "en") {
                window.location.href = CONSTANTS.redirects.REQUESTTOMA_EN;
            } else {
                window.location.href = CONSTANTS.redirects.REQUESTTOMA_FR;
            }
        }
        else if(!this.isReferralMaPresent) {
            if (this.currentLang == "en") {
                window.location.href = CONSTANTS.redirects.FIND_ADVISOR_EN;
            }
            else {
                window.location.href = CONSTANTS.redirects.FIND_ADVISOR_FR;
            }
        }
     
    }
    goTo() {
        if (this.currentLang == "en") {
            window.location.href = environment.api.mortgageHome_en;
        } else {
            window.location.href = environment.api.mortgageHome_fr;
        }
    }
    setSidebar() {
        if (this.isReferralMaPresent) {
            this.util.sidebarTitle.next('slideTitles.advisor');
        }
        else {
            this.util.sidebarTitle.next('slideTitles.advisorWithoutMA');
        }
    }
    ngOnDestroy() {
        if (this.unSubMaAssigned != undefined) {
            this.unSubMaAssigned.unsubscribe();
        }
    }
}